import TYPES from '@/modules/shared/types';

// Domain
import { CreateCustomerKuspitAccountRepository } from '../../../domain/repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CreateCustomerKuspitAccountHttpRepository
implements CreateCustomerKuspitAccountRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/kuspit/customer-account/`;

  create(customer_id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(
        this.endpoint,
        'POST',
        { id: customer_id },
      )
        .then((response) => {
          response.json()
            .then(({ success, message }) => {
              if (success) {
                resolve();
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
